(function() {
  var KEY = 'vj_wishlist_v1';

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function set(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    notify();
  }
  function has(handle) { return get().indexOf(handle) !== -1; }
  function add(handle) {
    var list = get();
    if (list.indexOf(handle) === -1) { list.push(handle); set(list); }
  }
  function remove(handle) {
    var list = get().filter(function(h) { return h !== handle; });
    set(list);
  }
  function toggle(handle) {
    if (has(handle)) { remove(handle); return false; }
    add(handle); return true;
  }

  function paintButton(btn) {
    var handle = btn.getAttribute('data-vj-wishlist-toggle');
    if (!handle) return;
    var active = has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var svg = btn.querySelector('svg');
    if (svg) svg.setAttribute('fill', active ? 'currentColor' : 'none');
    var label = btn.querySelector('.vj-wishlist-label');
    if (label) label.textContent = active ? 'In your Wishlist' : 'Add to Wishlist';
  }

  function paintAllButtons() {
    document.querySelectorAll('[data-vj-wishlist-toggle]').forEach(paintButton);
  }

  function paintCounts() {
    var n = get().length;
    document.querySelectorAll('[data-vj-wishlist-count]').forEach(function(el) {
      el.textContent = n > 0 ? n : '';
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function notify() {
    paintAllButtons();
    paintCounts();
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('[data-vj-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-vj-wishlist-toggle');
    if (!handle) return;
    var nowActive = toggle(handle);
    paintButton(btn);
    paintCounts();
    if (!nowActive) {
      var card = btn.closest('.vj-card, .vj-product-card');
      var grid = document.getElementById('vj-wishlist-grid');
      if (card && grid && grid.contains(card)) {
        card.remove();
        if (!grid.children.length) {
          grid.style.display = 'none';
          var empty = document.getElementById('vj-wishlist-empty');
          if (empty) empty.style.display = 'block';
        }
      }
    }
  }, false);

  window.addEventListener('storage', function(e) {
    if (e.key === KEY) notify();
  });

  function init() { notify(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.vjWishlist = {
    get: get, has: has, add: add, remove: remove, toggle: toggle,
    refresh: notify
  };

  /* ── Global "Add to Cart" handler for product cards & quick-add bag icon ──
     Any [data-vj-add-cart] element anywhere on the site (collection/search/related/home/wishlist/cart-saved)
     adds the variant via AJAX without leaving the page. Updates the header cart badge
     ([data-vj-cart-count]) on success and shows the confirmation popup with
     "View Cart / Checkout / Continue shopping" actions. */
  function updateCartCountBadges(count) {
    document.querySelectorAll('[data-vj-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* Tiny check ✓ SVG used to briefly confirm "added" on icon-only buttons. */
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function moneyFmt(cents) {
    var n = cents / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Confirmation popup shown after any successful add-to-cart.
     - Shows the just-added line item (image, title, price)
     - "View Cart (N)" + "Checkout" actions + "Continue shopping" link
     - Closes on backdrop tap, ✕ button, or Escape. Auto-closes after 8s. */
  window.vjShowCartPopup = function(lineItem, cartCount) {
    var existing = document.getElementById('vj-cart-popup');
    if (existing) existing.remove();

    var imgUrl = '';
    if (lineItem) {
      imgUrl = lineItem.image
        || (lineItem.featured_image && (lineItem.featured_image.url || lineItem.featured_image));
    }
    if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;

    var title = (lineItem && (lineItem.product_title || lineItem.title)) || '';
    var price = lineItem && (lineItem.final_price || lineItem.price);

    var pop = document.createElement('div');
    pop.id = 'vj-cart-popup';
    pop.className = 'vj-cart-popup';
    pop.innerHTML =
      '<div class="vj-cart-popup-backdrop" data-vj-popup-close></div>' +
      '<div class="vj-cart-popup-panel" role="dialog" aria-modal="true" aria-label="Item added to cart">' +
        '<button type="button" class="vj-cart-popup-x" data-vj-popup-close aria-label="Close">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="vj-cart-popup-status">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span>Added to your cart</span>' +
        '</div>' +
        (imgUrl || title
          ? '<div class="vj-cart-popup-product">' +
              (imgUrl ? '<div class="vj-cart-popup-img"><img src="' + escHtml(imgUrl) + '" alt=""/></div>' : '') +
              '<div class="vj-cart-popup-info">' +
                (title ? '<div class="vj-cart-popup-title">' + escHtml(title) + '</div>' : '') +
                (price ? '<div class="vj-cart-popup-price">' + moneyFmt(price) + '</div>' : '') +
              '</div>' +
            '</div>'
          : '') +
        '<div class="vj-cart-popup-actions">' +
          '<a href="/cart" class="vj-btn vj-btn-outline vj-cart-popup-cart">View Cart (' + (cartCount || '') + ')</a>' +
          '<a href="/checkout" class="vj-btn vj-btn-solid vj-cart-popup-checkout">Checkout</a>' +
        '</div>' +
        '<button type="button" class="vj-cart-popup-continue" data-vj-popup-close>Continue shopping</button>' +
      '</div>';
    document.body.appendChild(pop);
    requestAnimationFrame(function() { pop.classList.add('is-open'); });

    var autoClose = setTimeout(function() { closeCartPopup(); }, 8000);
    pop.addEventListener('mouseenter', function() { clearTimeout(autoClose); });
  };

  function closeCartPopup() {
    var pop = document.getElementById('vj-cart-popup');
    if (!pop) return;
    pop.classList.remove('is-open');
    setTimeout(function() { if (pop.parentNode) pop.remove(); }, 220);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('[data-vj-popup-close]')) closeCartPopup();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartPopup();
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('[data-vj-add-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalHTML = btn.innerHTML;
    var hasText = btn.textContent.trim().length > 0 && !btn.querySelector('svg');
    btn.disabled = true;
    btn.classList.remove('is-error', 'is-added');
    btn.classList.add('is-loading');
    var addedItem = null;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function(item) {
      addedItem = item;
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = hasText ? 'Added ✓' : CHECK_SVG;
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      updateCartCountBadges(cart.item_count);
      /* Skip the "Continue shopping / View Cart / Checkout" popup when the user
         is already inside the cart view — they don't need those CTAs there. */
      var skipPopup = btn.hasAttribute('data-vj-no-popup');
      if (!skipPopup && typeof window.vjShowCartPopup === 'function') {
        window.vjShowCartPopup(addedItem, cart.item_count);
      }
    })
    .catch(function() {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.innerHTML = hasText ? 'Try again' : '<span aria-hidden="true">!</span>';
    })
    .finally(function() {
      setTimeout(function() {
        btn.classList.remove('is-added', 'is-error');
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }, 1400);
    });
  }, false);

  /* ── Save-for-Later from the cart line item ──
     Adds the product handle to the wishlist (localStorage), then submits the
     line-item removal form so the row disappears from the cart. */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('[data-vj-save-for-later]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    var removeUrl = btn.getAttribute('data-remove-url');
    if (handle) add(handle);
    if (removeUrl) window.location.href = removeUrl;
  });
})();
